module.exports = __webpack_public_path__ + "img/favorites.a9127a3d.png";